// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"db65e3b1","977":"6ab075b0"}[chunkId] + ".chunk.js";
};